import '@fontsource-variable/darker-grotesque';
import '@fontsource-variable/urbanist';

import { darkScrollbar } from '@mui/material';
import { frFR } from '@mui/material/locale';
import { createTheme, Theme } from '@mui/material/styles';

import { ColorsRaw } from '@/ui/theme/colors-raw';

import { Fonts } from './fonts';

const options = frFR;

export const theme: Theme = createTheme(
  {
    palette: {
      mode: 'dark',
      primary: {
        main: ColorsRaw.main.Navy_Light,
      },
      secondary: {
        main: ColorsRaw.main.Navy_Dark,
      },
      text: {
        primary: ColorsRaw.basic.Cream,
      },
      background: {
        default: ColorsRaw.anthracite.Anthracite_1,
        paper: ColorsRaw.anthracite.Anthracite_3,
      },
      info: {
        main: ColorsRaw.anthracite.Anthracite_4,
        contrastText: ColorsRaw.basic.Cream,
      },
    },
    typography: {
      fontFamily: Fonts.Urbanist,
      h5: {
        fontSize: '2.875rem',
        fontWeight: 'bold',
        fontFamily: Fonts.DarkerGrotesque,
      },
      h6: {
        fontSize: '1.4rem',
        fontWeight: 'bold',
        fontFamily: Fonts.DarkerGrotesque,
      },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: () => ({
          body: darkScrollbar(),
        }),
      },
      MuiChip: {
        styleOverrides: {
          root: {
            borderRadius: 8,
            fontSize: 15,
          },
        },
      },
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            fontSize: '1rem',
            backgroundColor: 'rgb(97 97 97)',
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: ({ ownerState }) => ({
            ...(ownerState.variant === 'contained' &&
              ownerState.color === 'info' && {
                '&:hover': {
                  backgroundColor: ColorsRaw.anthracite.Anthracite_4,
                  filter: 'brightness(1.2)',
                },
              }),
            ...(ownerState.variant !== 'contained' &&
              ownerState.color === 'info' && {
                color: ColorsRaw.basic.Cream,
              }),
            ...(ownerState.variant === 'outlined' &&
              ownerState.color === 'info' && {
                borderColor: ColorsRaw.anthracite.Anthracite_5,
                '&:hover': {
                  borderColor: ColorsRaw.basic.Cream,
                  backgroundColor: ColorsRaw.anthracite.Anthracite_3,
                },
              }),
          }),
        },
      },
      MuiCircularProgress: {
        styleOverrides: {
          root: {
            color: ColorsRaw.basic.Cream,
          },
        },
      },
    },
  },
  options,
);
